import { useEffect, useState } from "react";
import { Alert, Forms } from "..";
import { FxTranslate } from "../../core/translate";
import { PersonaEditIn } from "../../model/seguridad";
import API from "../../services/api";
import Common from "../../services/common";
import CnetDropDown from "./CnetDropdown";
import { Button, Toolbar } from "../prime";

export interface CnetPersonaFormProps {
  t: FxTranslate;

  readonly?: boolean;

  /** entidad a editar */
  entity: PersonaEditIn | undefined;

  /** Indica si el botón grabar invoca al API para que guarde los cambios o solo devuelve el objeto modificado */
  saveToAPI: boolean;

  /** Ocurre cuando se guardan los cambios */
  onSave: (entity: PersonaEditIn) => void;
  
  /** Ocurre cuando se cierra el formulario sin guardar */
  onHide: (entity: PersonaEditIn) => void;
}
function CnetPersonaForm({ t, readonly, entity: _entity, saveToAPI, onSave, onHide } : CnetPersonaFormProps) {
  const [ entity, setEntity ] = useState<PersonaEditIn>();
  useEffect(() => {
    const ent = { ...(_entity ?? {}) };
    if (!ent.documentos || ent.documentos.length < 1) ent.documentos = [{ principal: true }]
    if (!ent.emails || ent.emails.length < 1) ent.emails = [{ principal: true }]
    if (!ent.telefonos || ent.telefonos.length < 1) ent.telefonos = [{ principal: true }]
    if (!ent.domicilios || ent.domicilios.length < 1) ent.domicilios = [{ principal: true }]
    setEntity({ ...ent })
  }, [_entity]);
  
  const clearEntity = (entity: PersonaEditIn) => {
    var ent = { ...entity };
    ent.documentos = ent.documentos!.filter(p => (p.numero??"").length > 1);
    ent.emails = ent.emails!.filter(p => (p.correo??"").length > 1);
    ent.telefonos = ent.telefonos!.filter(p => (p.numero??"").length > 1);
    ent.domicilios = ent.domicilios!.filter(p => (p.calle??"").length > 1);
    return ent;
  }

  const save = () => {
    if (!saveToAPI) return onSave(clearEntity(entity!));
    
    API.SeguridadController().Persona().upsert(clearEntity(entity!)).then(res => {
      if (!res.success) return Alert.reponse(res);
      onSave(entity!);
    }).catch(ex => Alert.exception(t, ex));
  }

  return <>
    <CnetDropDown
      t={t} title={t("@BO/Componente/CnetPersonaForm#nacionalidad")}
      value={entity?.idNacionalidad}
      optionsAsync={(activos) => API.SeguridadController().Pais().combo({ activos, includeNinguno: true })}
      optionsTransform={(rows) => Common.array.ComboItem(t, rows)}
      onChange={e => setEntity({ ...entity, idNacionalidad: e.value })}
      placeholder={t("@Id#SinSeleccionar")}
      optionLabel="show" optionValue="id" 
    />
    <Forms.Input title={t("@BO/Componente/CnetPersonaForm#nombre")} required disabled={readonly} value={entity?.nombre} onChange={(v, e) => setEntity({ ...entity, nombre: v })} />
    <Forms.Input title={t("@BO/Componente/CnetPersonaForm#apellido")} disabled={readonly} value={entity?.apellido} onChange={(v, e) => setEntity({ ...entity, apellido: v })} />
    <Forms.Calendar title={t("@BO/Componente/CnetPersonaForm#nacimiento")} disabled={readonly} value={!!entity?.nacimiento ? new Date(entity.nacimiento) : undefined} onChange={(v, e) => setEntity({ ...entity, nacimiento: v })} />
    <Forms.Input title={t("@BO/Componente/CnetPersonaForm#documentos")} disabled={readonly} value={entity?.documentos![0].numero} onChange={(v, e) => { entity!.documentos![0].numero = v;  setEntity({ ...entity }) }} />
    <Forms.Input title={t("@BO/Componente/CnetPersonaForm#emails")} disabled={readonly} email value={entity?.emails![0].correo} onChange={(v, e) => { entity!.emails![0].correo = v;  setEntity({ ...entity }) }} />
    <Forms.Input title={t("@BO/Componente/CnetPersonaForm#telefonoarea")} disabled={readonly} value={entity?.telefonos![0].area} onChange={(v, e) => { entity!.telefonos![0].area = v;  setEntity({ ...entity }) }} />
    <Forms.Input title={t("@BO/Componente/CnetPersonaForm#telefonos")} disabled={readonly} value={entity?.telefonos![0].numero} onChange={(v, e) => { entity!.telefonos![0].numero = v;  setEntity({ ...entity }) }} />
    <Forms.Input title={t("@BO/Componente/CnetPersonaForm#domicilios")} disabled={readonly} value={entity?.domicilios![0].calle} onChange={(v, e) => { entity!.domicilios![0].calle = v;  setEntity({ ...entity }) }} />

    <Toolbar
      left={<>
        <Button label={t("@BO/Componente/CnetPersonaForm#Save")} className="p-button-success" style={{ marginRight: 8 }} disabled={readonly} onClick={save}/>
        <Button label={t("@BO/Componente/CnetPersonaForm#Cancel")} className="p-button-secondary" onClick={() => onHide(clearEntity(entity!))} />
      </>}
    />
  </>
}


export default CnetPersonaForm;